import { render, staticRenderFns } from "./OrderLog.vue?vue&type=template&id=65ac5653&scoped=true&"
import script from "./OrderLog.vue?vue&type=script&lang=js&"
export * from "./OrderLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ac5653",
  null
  
)

export default component.exports